import LogoSpinner from 'common/components/logoSpinner/LogoSpinner';
import { useStores } from 'common/hooks/useStores';
import { observer } from 'mobx-react';
import React, { lazy, Suspense } from 'react';

const AuthContainer = lazy(() => import('components/auth/AuthContainer'));
const UserContainer = lazy(() => import('components/UserContainer'));

const Bootstrap = () => {
    const { authStore } = useStores();
    const { authenticated } = authStore;

    return (
        <div className="app-container">
            <Suspense fallback={<LogoSpinner />}>
                {authenticated === false && <AuthContainer />}
                {authenticated === true && <UserContainer />}
            </Suspense>
        </div>
    );
};

export default observer(Bootstrap);
